const headerElement = document.querySelector("header.header")
const bannerElement = document.querySelector(".banner")

export function updateNavOffset() {
  if (!headerElement) return
  const scrolled = headerElement.classList.contains("header--on-the-move")
  const bannerVisible = bannerElement && !bannerElement.classList.contains("banner--hidden")

  if (!bannerVisible) {
    // No banner: remove JS override and let CSS fallback (--header-height) handle positioning
    headerElement.style.removeProperty("--banner-header-height")
    return
  }

  const bannerOffset = scrolled ? 0 : bannerElement.scrollHeight
  const headerHeight = headerElement.getBoundingClientRect().height
  headerElement.style.setProperty("--banner-header-height", `${bannerOffset + headerHeight}px`)
}

export function listenForScroll() {
  updateNavOffset()

  addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      headerElement.classList.add("header--on-the-move")
    }
    if (window.scrollY < 50) {
      headerElement.classList.remove("header--on-the-move")
    }
    updateNavOffset()
  })

  addEventListener("resize", updateNavOffset)
}